import { Navigate, Outlet, useNavigate } from "react-router-dom"
import useLocalStorageState from "use-local-storage-state"
import Header from "./Layout/header";
import Aside from "./Layout/aside";
// import Footer from "./Layout/footer";
import { useEffect, useState } from "react";
// import { Subscription } from "./pages/Subscription";

import { askNotificationPermission, sendNotification } from './Utils/Notification'; import { formatDate, formatTime } from "./Utils/helpers/commonhelper";
import { GetRequest } from "./Utils/hooks/ApiHandler";

export const Protected = () => {
    const [customer, setCustomer] = useLocalStorageState('customer')
    const [isHovered, setIsHovered] = useState(false);
    const [isOpen, setIsOpen] = useState(true);

    const navigate = useNavigate();
    const LoginUserId = customer.customer_details?.id;
    const token = customer.token?.authorization;
    const rf = customer.token?.authentication;
    const headers = {
        authentication: rf,
        Authorization: token
    }
    const extras = { customer, setCustomer, rf, navigate };

    // useEffect(() => {
    //     if (!LoginUserId || LoginUserId === undefined) return
    //     const fetchNotification = async () => {
    //         await Promise.all([
    //             fetchDataForTaskBeforeDueTime(),
    //             fetchDataForTaskOnTime(),
    //             fetchDataForMettingBeforeDueTime(),
    //             fetchDataForMettingOnTime(),
    //         ])
    //     }
    //     fetchNotification()
    //     const interval = setInterval(() => fetchNotification, 60000);

    //     return () => clearInterval(interval);
    // }, [LoginUserId]);
    useEffect(() => {
        if (!LoginUserId) return;
        const fetchNotification = async () => {
            try {
                await Promise.all([
                    fetchDataForTaskBeforeDueTime(),
                    fetchDataForTaskOnTime(),
                    fetchDataForMettingBeforeDueTime(),
                    fetchDataForMettingOnTime(),
                ]);
            } catch (error) {
                console.error("Notification fetch error:", error);
            }
        };
        fetchNotification();
        const interval = setInterval(() => {
            fetchNotification();
        }, 60000);
        return () => clearInterval(interval);
    }, [LoginUserId]);

    const toggleSidebar = () => setIsOpen(prev => !prev);
    if (!customer || customer?.user_login === undefined || customer?.customer_status === undefined || customer?.user_login === false || customer?.customer_status === "Inactive") {
        return <Navigate to="/" replace />;
    }
    const isFree = customer.customer_details?.is_plan === "no" ? false : true
    if (!isFree) {
        return <Navigate to={"/plans"} replace />
    }

    //  API Call + Notifications
    const fetchDataForTaskBeforeDueTime = async () => {
        await askNotificationPermission();

        try {
            const response = await GetRequest(
                `/Notification/taskNotificationBeforeDueTime/${LoginUserId}`,
                { headers },
                extras
            );
            if (response.status === "fail" || response.success === false) {
                return
            }
            response?.data && response?.data?.forEach((task, index) => {
                setTimeout(() => {
                    sendNotification(
                        `Task: ${task?.name} (${task.priority})`,
                        `${task?.description}\nDue: ${formatDate(task?.due_date)} at ${formatTime(task?.due_time)}`
                    );
                }, index * 3000);
            });
        } catch (error) {
            console.error("Error fetching API:", error);
        }
    };

    const fetchDataForTaskOnTime = async () => {
        await askNotificationPermission();
        try {
            const response = await GetRequest(
                `/Notification/taskNotificationOnTime/${LoginUserId}`,
                { headers },
                extras
            );

            if (response.status === "fail" || response.success === false) {
                return
            }
            response && response.forEach((task, index) => {
                setTimeout(() => {
                    sendNotification(
                        `Task: ${task.name} (${task.priority})`,
                        `${task.description}\nDue: ${task.due_date} at ${task.due_time}`
                    );
                }, index * 3000);
            });
        } catch (error) {
            console.error("Error fetching API:", error);
        }
    }

    const fetchDataForMettingBeforeDueTime = async () => {
        await askNotificationPermission();

        try {
            const response = await GetRequest(
                `/Notification/fetchMeetingBeforeDueTime/${LoginUserId}`,
                { headers },
                extras
            );

            if (response.status === "fail" || response.success === false) {
                return
            }
            response?.data && response?.data?.forEach((task, index) => {
                setTimeout(() => {
                    sendNotification(
                        `Task: ${task.meeting_title} (${task.meeting_type})`,
                        `${task.description}\nDue: ${task.meeting_date} at ${task.meeting_from}`
                    );
                }, index * 3000);
            });
        } catch (error) {
            console.error("Error fetching API:", error);
        }
    }
    const fetchDataForMettingOnTime = async () => {
        await askNotificationPermission();

        try {
            const response = await GetRequest(
                `/Notification/fetchMeetingOnTime/${LoginUserId}`,
                { headers },
                extras
            );

            if (response.status === "fail" || response.success === false) {
                return
            }
            response?.data && response?.data?.forEach((task, index) => {
                setTimeout(() => {
                    sendNotification(
                        `Task: ${task.meeting_title} (${task.meeting_type})`,
                        `${task.description}\nDue: ${task.meeting_date} at ${task.meeting_from}`
                    );
                }, index * 3000);
            });
        } catch (error) {
            console.error("Error fetching API:", error);
        }
    }

    return (
        <>

            <>
                <Header toggleSidebar={toggleSidebar} isOpen={isOpen} isHovered={isHovered} />
                <Aside isOpen={isOpen} isHovered={isHovered} setIsHovered={setIsHovered} />
                <main style={{ marginTop: '4.5rem', paddingLeft: '4.5rem', marginRight: '1.4%' }}>
                    <Outlet></Outlet>
                </main>
            </>
            {/* <Footer isOpen={isOpen} /> */}
        </>

    )
}